import React, { useEffect, useState } from 'react';
import { Container, Header, ExpandButton, IconContainer } from '../../Tabs.styles';
import CustomTitle from '../../../CustomTitle/index';
import { Grid, VideoContainer, PlayIcon, Overlay } from './CollapsibleVideos.styles';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import VideoPreviewModal from '../../../../VideoPreviewModal';
import ReactPlayer from 'react-player';
import YoutubeVideoPreviewModal from '../../../../MediaBrowser/YoutubeVideoPreviewModal';
import EmptyContent from '../../../EmptyContent'

const CollapsibleVideos = ({ videos = [], icon, title, segmentColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isNormalVideoModal, setIsNormalVideoModal] = useState(false);
  const [isYoutubeVideoModal, setIsYoutubeVideoModal] = useState(false);

  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);

  const toggleExpand = () => {
    if (videos.length > 3) {
      setIsExpanded(!isExpanded);
    }
  };

  const visibleVideos = isExpanded ? videos : videos.slice(0, 3);

  const openModal = (url) => {
    setSelectedVideoUrl(url);
    const regex = /youtube\.com\/embed\/([^"&?\/\s]{11})/;
    const match = url.match(regex);

    if (match && match[1]) {
      setIsYoutubeVideoModal(true);
    } else {
      setIsNormalVideoModal(true);
    }
  };

  const closeModal = () => {
    setSelectedVideoUrl(null);
    setIsNormalVideoModal(false);
    setIsYoutubeVideoModal(false);
  };

  const VideoThumbnail = ({ url }) => {
    const [isYouTube, setIsYouTube] = useState(false);
    const [thumbnailURL, setThumbnailURL] = useState(null);

    useEffect(() => {
      // Check if the URL is a YouTube embed link
      const regex = /youtube\.com\/embed\/([^"&?\/\s]{11})/;
      const match = url.match(regex);

      if (match && match[1]) {
        const videoID = match[1];

        // Construct the thumbnail URL for YouTube video
        const thumbnail = `https://img.youtube.com/vi/${videoID}/hqdefault.jpg`;

        setThumbnailURL(thumbnail);
        setIsYouTube(true);
      } else {
        setIsYouTube(false);
      }
    }, [url]);

    if (videos.length === 0) {
      return <EmptyContent />;
    }

    return (
      <VideoContainer onClick={() => openModal(url)}>
        {isYouTube ? (
          <img
            src={thumbnailURL}
            alt="YouTube Video Thumbnail"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '6px',
            }}
          />
        ) : (
          <div
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              borderRadius: '6px',
              backgroundColor: 'black',
            }}
          >
            <ReactPlayer url={url} width={'100%'} height={'100%'} playing={false} />
          </div>
        )}
        <Overlay className="overlay" />
        <PlayIcon className="play-icon" />
      </VideoContainer>
    );
  };

  return (
    <Container>
      <Header>
        <IconContainer bgColor={segmentColor}></IconContainer>
        <CustomTitle title={title} count={videos.length} />
        <ExpandButton showIcon={videos.length > 3} onClick={toggleExpand}>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </ExpandButton>
      </Header>

      <Grid>
        {visibleVideos.map((video, index) => (
          <VideoThumbnail key={index} url={video?.src} />
        ))}
      </Grid>

      <VideoPreviewModal
        openPreviewVideo={isNormalVideoModal}
        handleClosePreviewVideo={closeModal}
        videoUrl={selectedVideoUrl}
      />
      <YoutubeVideoPreviewModal
        openPreviewVideo={isYoutubeVideoModal}
        handleClosePreviewVideo={closeModal}
        videoUrl={selectedVideoUrl}
      />
    </Container>
  );
};

export default CollapsibleVideos;
